import * as React from "react";
import { SVGProps } from "react";
const SvgTreeLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M16.5 0C17.75 0 25 13 25 20c0 4.66-3.04 7.582-7.5 7.959V31a1 1 0 1 1-2 0v-3.041C11.04 27.582 8 24.659 8 20c0-7 7.25-20 8.5-20Z"
    />
  </svg>
);
export default SvgTreeLarge;
